export interface Locker {
  id: number;
  officeId: number;
  officeName?: string;
  rootOfficeId: number;
  label: string;
  active: boolean;
  assigned: boolean;

  // Admin only. The backend omits these for ordinary members, so never assume they are present.
  assignedUserId?: string;
  assignedUserName?: string;
  assignedAt?: string;
}

export interface LockerOfficeSummary {
  officeId: number;
  officeName?: string;
  totalLockers: number;
  assignedLockers: number;
  availableLockers: number;
  waitingListCount: number;
}

export interface WaitingListEntry {
  id: number;
  position: number;
  userId?: string;
  userName?: string;
  createdAt: string;
}

export interface WaitingList {
  officeId: number;
  totalWaiting: number;
  /** The caller's own position, or null when they are not queued. */
  myPosition?: number | null;
  /** Full queue for admins. For members this holds only their own entry. */
  entries: WaitingListEntry[];
}

export interface CreateLockerRequest {
  officeId: number;
  label: string;
}

export interface UpdateLockerRequest {
  officeId: number;
  label: string;
  active?: boolean;
}

/** The stat cards and the segmented control are two ways of setting the same filter. */
export enum LockerStatusFilter {
  All = 'all',
  Available = 'available',
  Assigned = 'assigned',
}

export enum WaitingListSort {
  Position = 'position',
  LongestWaiting = 'longest-waiting',
  Name = 'name',
}
